module.exports = __webpack_public_path__ + "static/NewBaskervilleStd-BoldIt-29db92ace6fb112fd8484b9c51ee18c1.woff";